const latestNotificationSelector = state => state?.latestNotification?.latest_notification;
export default latestNotificationSelector;